import { useEffect, useMemo, useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { BrandLogo } from '../../../../_UI/BrandLogo';

export const PortfolioNavbar = ({
    profile = {},
    hasAbout = false,
    hasProjects = false,
    hasSaleProjects = false,
    hasExperience = false,
    hasBlog = false,
}) => {
    const [active, setActive] = useState('home');
    const [open, setOpen] = useState(false);

    const nav = useMemo(() => [
        ['home', 'Inicio', true],
        ['sobre-mi', 'Sobre mi', hasAbout],
        ['proyectos', 'Proyectos', hasProjects],
        ['proyectos-en-venta', 'En venta', hasSaleProjects],
        ['experiencia', 'Trayectoria', hasExperience],
        ['blog', 'Blog', hasBlog],
    ].filter(([, , enabled]) => enabled), [hasAbout, hasProjects, hasSaleProjects, hasExperience, hasBlog]);

    useEffect(() => {
        const onScroll = () => {
            let current = 'home';
            const y = window.scrollY + 130;
            document.querySelectorAll('.PB__portfolio section[id]').forEach((section) => {
                if (y >= section.offsetTop && y < section.offsetTop + section.offsetHeight) current = section.id;
            });
            setActive(current);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const go = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setOpen(false);
    };

    return (
        <header className="PB__navbar">
            <div className="PB__container PB__navbar_inner">
                {/*
                    LOGO BAILADOR
                    El archivo real vive en public/_Imgs/_Brand/LS_BRAND_dark.png.
                    No volver a escribir Gaston/Bailador a mano en este navbar.
                */}
                <button type="button" className="PB__brand" onClick={() => go('home')} aria-label="Ir al inicio">
                    <BrandLogo slot="HEADER_PUBLIC" className="PB__brand_logo" fallback={profile.brand || 'Bailador'} />
                </button>
                <button type="button" className="PB__nav_toggle" onClick={() => setOpen((v) => !v)} aria-label="Abrir menu">
                    {open ? <FiX /> : <FiMenu />}
                </button>
                <nav className={`PB__nav_links ${open ? 'is-open' : ''}`}>
                    {nav.map(([id, label]) => (
                        <button key={id} type="button" className={active === id ? 'active' : ''} onClick={() => go(id)}>{label}</button>
                    ))}
                    <a className="PB__admin_link" href="/ingresar">Admin</a>
                </nav>
            </div>
        </header>
    );
};
